import { getOrderProcessManifestsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type {
  ManifestAsyncFileExportResponseDto,
  ManifestExportQueryDto,
} from '@b-stock/order-process-api-client'

export const fetchManifestExport = async (
  accessToken: string | null,
  manifestExportQueryDto: ManifestExportQueryDto
): Promise<ManifestAsyncFileExportResponseDto> => {
  const client = getOrderProcessManifestsClient()

  const { data } = await client.getManifestExportAsync(
    { manifestExportQueryDto },
    buildAxiosRequestConfig({ accessToken })
  )

  return data
}
